module.exports = __webpack_public_path__ + "img/02.28ef61c0.jpg";